import { useCallback, useState } from "react";

import { notify } from "../Notification";
import { ErrorResponse, getErrorMessages } from "../../services";
import { useDeleteCashbackAdjustmentMutation } from "../../services/accounts/accountsApi";
import { ADJUSTMENT_LABEL } from "./constants";
import {
  PendingCorrection,
  UseCorrectionDeleteProps,
  UseCorrectionDeleteReturn,
} from "./types";

export const useCorrectionDelete = ({
  accountId,
  onDeleted,
}: UseCorrectionDeleteProps): UseCorrectionDeleteReturn => {
  const [pendingCorrection, setPendingCorrection] =
    useState<PendingCorrection | null>(null);
  const [deleteError, setDeleteError] = useState<string | null>(null);
  const [deleteAdjustment, { isLoading: isDeleting }] =
    useDeleteCashbackAdjustmentMutation();

  const closeDelete = useCallback(() => {
    setPendingCorrection(null);
    setDeleteError(null);
  }, []);

  const confirmDelete = async () => {
    if (!pendingCorrection) {
      return;
    }
    try {
      await deleteAdjustment({
        accountId,
        adjustmentId: pendingCorrection.id,
      }).unwrap();
      notify.success(`${ADJUSTMENT_LABEL} deleted`);
      closeDelete();
      onDeleted?.();
    } catch (error: unknown) {
      setDeleteError(getErrorMessages(error as ErrorResponse).join(" "));
    }
  };

  return {
    pendingCorrection,
    deleteError,
    isDeleting,
    requestDelete: setPendingCorrection,
    closeDelete,
    confirmDelete,
  };
};
